import { observer } from 'mobx-react'

import buildUrl from 'modules/core/lib/buildUrl'
import { isAbsoluteURL } from 'modules/core/lib/isAbsoluteURL'

import Factorial from './Factorial'
import './index.styles.css'
interface Props {
  companyLogo?: string | null
  alt: string
  width?: number
  height?: number
}

function Logo({ companyLogo, alt, width, height }: Props) {
  let url = buildUrl(companyLogo)

  if (isAbsoluteURL(companyLogo || '')) {
    url = companyLogo || ''
  }

  if (companyLogo) {
    return <img src={url} height={height || 40} alt={alt} className={'Logo_image'} />
  }

  return <Factorial height={height} width={width} />
}

export default observer(Logo)
